export var Format;
(function (Format) {
    Format["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    Format["SVG"] = "SVG";
    Format["PNG"] = "PNG";
})(Format || (Format = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    RequestedFields["ALLOWED_CURRENCIES"] = "ALLOWED_CURRENCIES";
})(RequestedFields || (RequestedFields = {}));
//# sourceMappingURL=types.impl.js.map